import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import {
  HomeOutlined as HomeIcon,
  Inventory2Outlined as InventoryIcon,
  FastfoodOutlined as FastFoodIcon,
  MoneyOffOutlined as MoneyOffIcon,
  ShoppingCartOutlined as ShoppingCartIcon,
  PointOfSaleOutlined as PointOfSaleIcon,
  AccountBalanceOutlined as BankIcon,
  CreditCardOutlined as CreditCardIcon,
  GroupOutlined as GroupIcon,
  MenuOutlined as MenuIcon,
  AddCircleOutline as AddIcon,
  HistoryOutlined as HistoryIcon,
} from "@mui/icons-material";
import { tokens } from "../../theme";
import "react-pro-sidebar/dist/css/styles.css";
import logo from "../../assets/6-removebg.png"; // Replace with your logo path
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{
        backgroundColor: selected === title ? colors.grey[500] : "transparent",
        color: selected === title ? colors.grey[100] : (theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100]),
        borderRadius: "8px",
        transition: "all 0.2s ease-in-out",
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography variant="body1" fontWeight="500" color={theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100]}>
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({ setIsCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsedState] = useState(false);
  const [selected, setSelected] = useState(
    localStorage.getItem("selectedMenu") || "Dashboard"
  );
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { isAuthenticated, user } = useSelector((state) => state.user);

  useEffect(() => {
    localStorage.setItem("selectedMenu", selected);
  }, [selected]);

  useEffect(() => {
    setIsCollapsed(isCollapsed);
  }, [isCollapsed]);

  const handleCollapse = () => {
    setIsCollapsedState(!isCollapsed);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        height: "100vh",
        overflowY: "auto",
        zIndex: 1000,
        width: isCollapsed ? "80px" : "270px",
        transition: "width 0.3s ease",
        color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100],
        boxShadow: "2px 0 6px rgba(0, 0, 0, 0.1)",
        backgroundColor: theme.palette.mode === "light" ? "#ffffff" : colors.primary[700],
      }}
    >
      <ProSidebar
        collapsed={isCollapsed}
        style={{
          backgroundColor: theme.palette.mode === "light" ? "#ffffff" : colors.primary[700],
        }}
      >
        <Menu iconShape="circle">
          {/* Header Section */}
          <MenuItem
            onClick={handleCollapse}
            icon={isCollapsed ? <MenuIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h6" color={theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100]} fontWeight="bold">
                  ETABLISSEMENT ROSE
                </Typography>
                <IconButton onClick={handleCollapse}>
                  <MenuIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* User Section */}
          {!isCollapsed && isAuthenticated && (
            <Box textAlign="center" mb="20px">
              <img
                src={logo}
                alt="Logo"
                width="90px"
                height="90px"
                style={{
                  borderRadius: "50%",
                  backgroundColor: "white",
                  marginBottom: "10px",
                  border: `2px solid ${colors.greenAccent[500]}`,
                }}
              />
              <Typography variant="h6" color={theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100]} fontWeight="bold">
                {user.name}
              </Typography>
              <Typography variant="body2" color={colors.greenAccent[500]}>
                {user.role}
              </Typography>
            </Box>
          )}

          {/* Menu Items */}
          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Dashboard"
              to="/dashboard"
              icon={<HomeIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Produits"
              to="/produit"
              icon={<InventoryIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Les depenses"
              to="/depenses"
              icon={<MoneyOffIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Ventes produits"
              to="/vente"
              icon={<ShoppingCartIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <SubMenu title="Les ventes" icon={<PointOfSaleIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}>
              <Item
                title="Vente cash"
                to="/transaction/sales"
                icon={<PointOfSaleIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Vente Banque"
                to="/transaction/banque"
                icon={<BankIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Vente avec credit"
                to="/transaction/debt"
                icon={<CreditCardIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>
            {/* <Item
              title="Depot de l'argent"
              to="/retrait-depot"
              icon={<GroupIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            <Item
              title="Les interets et dettes"
              to="/product-analysis"
              icon={<HistoryIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Gestions utilisateurs"
              to="/team"
              icon={<GroupIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>
      </ProSidebar>

      {/* Toggle Button for Small Screens */}
      {isSmallScreen && (
        <Box position="fixed" bottom="20px" left="20px">
          <IconButton
            onClick={handleCollapse}
            sx={{
              backgroundColor: colors.primary[400],
              "&:hover": { backgroundColor: colors.primary[300] },
            }}
          >
            <MenuIcon sx={{ color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100] }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default Sidebar;
